export enum AccessibilityType {
  LIVE_ATTENDANCE = 'LIVE_ATTENDANCE',
  STREAMING = 'STREAMING',
}
